var _path, _path2, _path3, _path4, _path5, _path6, _circle, _circle2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgManifestTruckIcon(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 12,
    viewBox: "0 0 21 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.36798 9.63261H4.72266L4.87223 1L14.6801 1.10684V9.63261H11.1971",
    stroke: "#0073FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.7012 3.24341L18.2055 3.39298C18.3978 3.39298 18.8337 3.487 19.0388 3.86308C19.244 4.23915 19.7511 5.40156 19.979 5.93576V9.46145H18.5688",
    stroke: "#0073FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.6836 5.93604H19.9999",
    stroke: "#0073FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M0 2.53857H3.76074",
    stroke: "#0073FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M1.04688 4.67505H3.73922",
    stroke: "#0073FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M2.1582 6.85522H3.69669",
    stroke: "#0073FF"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8.67536,
    cy: 9.8675,
    r: 1.18806,
    stroke: "#0073FF"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 16.9244,
    cy: 9.8675,
    r: 1.18806,
    stroke: "#0073FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManifestTruckIcon);
export default __webpack_public_path__ + "static/media/manifestTruckIcon.88e2b5b87b27e86c1f50d1728a07d58f.svg";
export { ForwardRef as ReactComponent };